import { render, staticRenderFns } from "./ArrowsCaretSortIcon.vue?vue&type=template&id=331ec67d&"
import script from "./ArrowsCaretSortIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowsCaretSortIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports